module.exports = __webpack_public_path__ + "img/20190523195443微信截图_20190523195759.223c4b0c.png";